import { KEYS } from './constants/storage.constants';
import { errorCode } from './evergentUtils';

/**
 * Remove empty or undefined params
 *
 * @param attributes
 */
export const removeUndefined = (attributes: any) => {
  Object.keys(attributes).forEach((key) => {
    if (
      attributes[key] === null ||
      attributes[key] === undefined ||
      attributes[key] === '' ||
      attributes[key] === '[]' ||
      (Array.isArray(attributes[key]) && attributes[key]?.length === 0)
    ) {
      delete attributes[key];
    }
  });
  return attributes;
};

export const getErrorData = (error: any, errorType?: any): any => {
  let errorAttributes: any = {};

  errorAttributes = getArrayError(error);

  if (typeof error === 'string') {
    errorAttributes.errorDescription = error;
  }

  if (error) {
    if (errorType) {
      errorAttributes.errorType = errorType;
    }

    errorAttributes = { ...errorAttributes, ...getErrorAttributes(error) };

    if (error.internalError) {
      errorAttributes.internalError = error.internalError?.errorCode;
      errorAttributes.errorDescription = error.internalError;
    } else {
      if (error.errorMessage && error.errorCode) {
        errorAttributes.errorDescription = error;
      }
    }
    errorAttributes.storefrontID = localStorage.getItem(KEYS.STOREFRONT_ID);
  }
  return errorAttributes;
};

const getArrayError = (error: any) => {
  const errorAttributes: any = {};
  if (Array.isArray(error) && error?.length > 0) {
    if (error[0]) {
      if (error[0].errorCode) {
        errorAttributes.errorCode = error[0].errorCode;
      }
      if (error[0].errorMessage) {
        errorAttributes.errorMessage = error[0].errorMessage;
      }
      if (error[0].errorDescription) {
        errorAttributes.errorDescription = error[0].errorDescription;
      }
      errorAttributes.internalError = {
        error: { ...errorAttributes },
        errorType: errorAttributes.errorCode,
      };
    }
  }
  return errorAttributes;
};

const getErrorAttributes = (error: any) => {
  const attributes: any = {};
  if (error.errorCode) {
    attributes.errorCode = error.errorCode;
  }
  if (error.errorMessage) {
    attributes.errorMessage = error.errorMessage;
  }

  if (error.code) {
    attributes.code = error.code;
  }

  if (error.AddSubscriptionResponseMessage) {
    attributes.errorCode = errorCode(error);
  }
  if (error.productId) {
    attributes.productId = error.productId;
  }
  if (error.domain) {
    attributes.domain = error.domain;
  }
  if (error.desc) {
    attributes.description = error.desc;
  }
  if (error.debugMessage) {
    attributes.debugMessage = error.debugMessage;
  }

  if (error.message) {
    attributes.message = error.message;
  }
  if (error.productId) {
    attributes.productId = error.productId;
  }
  if (error.responseCode) {
    attributes.responseCode = error.responseCode;
  }

  if (error.hexErrorCode) {
    attributes.errorCode = error.hexErrorCode;
  }
  if (error.contextDescription) {
    attributes.errorMessage = error.contextDescription;
  }
  if (error.errorDescription) {
    attributes.description = error.errorDescription;
  }
  return attributes;
};
